import { useRef, useState } from 'react'
import { Input, Modal } from 'react-daisyui'
import { Button } from '@/components/Button.tsx'
import { IconLayout2 } from '@tabler/icons-react'

interface CreatePortfolioModalProps {
  modalRef: React.RefObject<HTMLDialogElement>
  onConfirm: (title: string) => void
  isLoading?: boolean
}

export function useCreatePortfolioModal() {
  const modalRef = useRef<HTMLDialogElement>(null)
  const show = () => modalRef.current?.showModal()
  const close = () => modalRef.current?.close()
  return { modalRef, show, close }
}

export function CreatePortfolioModal({ modalRef, onConfirm, isLoading }: CreatePortfolioModalProps) {
  const [title, setTitle] = useState('')

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!title.trim()) return
    onConfirm(title.trim())
  }

  return (
    <Modal ref={modalRef} className="bg-neutral">
      <Modal.Header>
        <div className="flex flex-col items-center gap-3 pt-2">
          <div className="bg-primary bg-opacity-20 text-primary rounded-full p-4">
            <IconLayout2 size={36} />
          </div>
          <span className="text-xl font-bold text-center">Neues Portfolio erstellen</span>
        </div>
        <form method="dialog">
          <button className="btn btn-sm btn-circle btn-ghost absolute right-5 top-5">✕</button>
        </form>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <label className="form-control w-full">
            <div className="label">
              <span className="label-text">Portfolioname</span>
            </div>
            <Input
              placeholder="z.B. Hochzeiten 2025"
              value={title}
              onChange={e => setTitle(e.target.value)}
              required
              autoFocus
            />
          </label>
          <div className="flex flex-row gap-3 justify-center">
            <Button type="button" color="ghost" disabled={isLoading}
              onClick={() => modalRef.current?.close()}>
              Abbrechen
            </Button>
            <Button type="submit" color="primary" loading={isLoading} disabled={isLoading || !title.trim()}>
              Erstellen
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}
